import React, {createContext, useEffect, useReducer, useRef, useState} from 'react'
// import axios from 'axios'
import axios, {getApiErrorPayload} from '../../../../axios.js'

import SetUnsetDeletedListTable from "../../../components/SetUnsetDeletedListTable/SetUnsetDeletedListTable";
import WarehouseDispositionDialog from '../../../components/WarehouseDispositionDialog'

const listStateKeys = [
    'referenceNotes', 'referenceNotesAll', 'refererNotesNew',
    'referenceOrderSource', 'referenceOrderSourceAll', 'refererOrderSourceNew',
    'referenceStatusOrder', 'referenceStatusOrderAll', 'refererStatusOrderNew',
    'referenceWriteOff', 'referenceWriteOffAll', 'refererWriteOffNew',
    'referenceTypePayments', 'referenceTypePaymentsAll', 'refererTypePaymentsNew',
    'referenceSelfWriting', 'referenceSelfWritingAll', 'referenceSelfWritingNew',
    'referenceWriting', 'referenceWritingAll', 'referenceWritingNew',
    'referenceMoving', 'referenceMovingAll', 'referenceMovingNew',
    'referenceConsignment', 'referenceConsignmentAll', 'referenceConsignmentNew',
    'referenceStocktaking', 'referenceStocktakingAll', 'referenceStocktakingNew',
    'referenceOutput', 'referenceOutputAll', 'referenceOutputNew',
    'referenceChangeList', 'referenceChangeListAll', 'referenceChangeListNew',
    'referenceMarks', 'referenceMarksAll', 'referenceMarksNew',
    'referenceSuppliers', 'referenceSuppliersAll', 'referenceSuppliersNew',
    'referenceUnits', 'referenceUnitsAll', 'referenceUnitsNew',
    'referenceStreet', 'referenceStreetAll', 'referenceStreetNew',
    'referenceMarkup', 'referenceMarkupAll', 'referenceMarkupNew',
    'referencePositionWorker', 'referencePositionWorkerAll', 'referencePositionWorkerNew',
    'referenceDiscount', 'referenceDiscountAll', 'referenceDiscountNew',
    'referenceOrganization', 'referenceOrganizationAll', 'referenceOrganizationNew',
    'referenceEmployeesList', 'referenceEmployeesListAll', 'referenceEmployeesListNew',
    'referenceUserList', 'referenceUserListAll', 'referenceUserListNew',
    'referencePromoCreate', 'referencePromoCreateAll', 'referencePromoCreateNew',
    'referenceCertificate', 'referenceCertificateAll', 'referenceCertificateNew',
    'referencePromocode', 'referencePromocodeAll', 'referencePromocodeNew',
    'affiliate', 'affiliateAll', 'affiliateNew',
    'gifts', 'giftsAll', 'giftsNew',
    'outlets', 'outletsAll', 'outletsNew',
    'category', 'categoryAll', 'categoryNew',
    'productTags', 'productTagsAll', 'productTagsNew',
    'productList', 'productListAll', 'productListNew',
]

const createInitialSystemServerInfoState = () => listStateKeys.reduce(
    (result, key) => ({ ...result, [key]: [] }),
    {
        systemColor: {},
        catalogLoadError: null,
        statusLoadServerInfo: false,
        catalogReady: false,
        orderReferencesReady: false,
        adminReferencesReady: false,
    }
)

const reducer = (state, action) => {
    // console.log('Загружаем в стейт новое состояние state =',state);
    // console.log('Загружаем в стейт новое состояние action =',action);
    switch (action.type) {
        case 'LOAD_COLOR': {
            // console.log('Сравниваем два стейта color старый и новый ',state.systemColor,action.payload);
            let OldData = JSON.stringify(state.systemColor);
            let NewData = JSON.stringify(action.payload);

            // console.log(OldData,NewData);
            if(OldData !== NewData){
                // console.log('Данные color не равны, заменяем новыми.');
                return {
                    ...state,
                    systemColor: action.payload,
                }
            }else{
                return state
            }

        }

        ///РАБОТА С ПОМЕТКАМИ
        case 'LOAD_NOTES': {
            // console.log('Сравниваем два стейта notes старый и новый ',state.referenceNotes,action.payload);
            let OldData = JSON.stringify(state.referenceNotes);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceNotes: SetUnsetDeletedListTable(action.payload),
                    referenceNotesAll: action.payload,
                }}else{
                return state
            }
        }
        case 'SET_UPDATE_NOTES': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceNotes, action.payload);
            let OldData = JSON.stringify(state.referenceNotes);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceNotes: SetUnsetDeletedListTable(action.payload),
                    referenceNotesAll: action.payload,
                }
            } else {
                return state
            }
        }



        /////работа с каналами продаж
        case 'LOAD_ORDER_SOURCE': {
            // console.log('Сравниваем два стейта notes старый и новый ',state.referenceOrderSource,action.payload);
            let OldData = JSON.stringify(state.referenceOrderSource);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceOrderSource: SetUnsetDeletedListTable(action.payload),
                    referenceOrderSourceAll: action.payload,
                }}else{
                return state
            }
        }
        case 'SET_UPDATE_ORDER_SOURCE': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceOrderSource, action.payload);
            let OldData = JSON.stringify(state.referenceOrderSource);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceOrderSource: SetUnsetDeletedListTable(action.payload),
                    referenceOrderSourceAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }



        //Работа с статусами заказов
        case 'LOAD_STATUS_ORDER': {
            // console.log('Сравниваем два стейта notes старый и новый ',state.referenceStatusOrder,action.payload);
            let OldData = JSON.stringify(state.referenceStatusOrder);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceStatusOrder: SetUnsetDeletedListTable(action.payload),
                    referenceStatusOrderAll: action.payload,
                }}else{
                return state
            }
        }
        case 'SET_UPDATE_STATUS_ORDER': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceStatusOrder, action.payload);
            let OldData = JSON.stringify(state.referenceStatusOrder);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceStatusOrder: SetUnsetDeletedListTable(action.payload),
                    referenceStatusOrderAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }


        //работа с списаниями
        case 'SET_UPDATE_WRITE_OFF': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceWriteOff, action.payload);
            let OldData = JSON.stringify(state.referenceWriteOff);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceWriteOff: SetUnsetDeletedListTable(action.payload),
                    referenceWriteOffAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_WRITE_OFF': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceWriteOff, action.payload);
            let OldData = JSON.stringify(state.referenceWriteOff);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceWriteOff: SetUnsetDeletedListTable(action.payload),
                    referenceWriteOffAll: action.payload,
                }
            } else {
                return state
            }
        }
        //работа с Типы платежей
        case 'SET_UPDATE_TYPE_PAYMENTS': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceTypePayments, action.payload);
            let OldData = JSON.stringify(state.referenceTypePayments);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceTypePayments: SetUnsetDeletedListTable(action.payload),
                    referenceTypePaymentsAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_TYPE_PAYMENTS': {
            // console.log('Сравниваем два стейта notes старый и новый ',state.referenceTypePayments,action.payload);
            let OldData = JSON.stringify(state.referenceTypePayments);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceTypePayments: SetUnsetDeletedListTable(action.payload),
                    referenceTypePaymentsAll: action.payload,
                }}else{
                return state
            }
        }
        //работа с Сдача
        case 'SET_UPDATE_CHANGELIST': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceChangeList, action.payload);
            let OldData = JSON.stringify(state.referenceChangeList);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceChangeList: SetUnsetDeletedListTable(action.payload),
                    referenceChangeListAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_CHANGELIST': {
            // console.log('Сравниваем два стейта ChangeList старый и новый ',state.referenceChangeList,action.payload);
            let OldData = JSON.stringify(state.referenceChangeList);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceChangeList: SetUnsetDeletedListTable(action.payload),
                    referenceChangeListAll: action.payload,
                }}else{
                return state
            }
        }
        //работа с Отметки
        case 'SET_UPDATE_MARKS': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceMarks, action.payload);
            let OldData = JSON.stringify(state.referenceMarks);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceMarks: SetUnsetDeletedListTable(action.payload),
                    referenceMarksAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_MARKS': {
            // console.log('Сравниваем два стейта Marks старый и новый ',state.referenceMarks,action.payload);
            let OldData = JSON.stringify(state.referenceMarks);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceMarks: SetUnsetDeletedListTable(action.payload),
                    referenceMarksAll: action.payload,
                }}else{
                return state
            }
        }
        //работа с Поставщики
        case 'SET_UPDATE_SUPPLIERS': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceSuppliers, action.payload);
            let OldData = JSON.stringify(state.referenceSuppliers);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceSuppliers: SetUnsetDeletedListTable(action.payload),
                    referenceSuppliersAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_SUPPLIERS': {
            // console.log('Сравниваем два стейта Suppliers старый и новый ',state.referenceSuppliers,action.payload);
            let OldData = JSON.stringify(state.referenceSuppliers);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceSuppliers: SetUnsetDeletedListTable(action.payload),
                    referenceSuppliersAll: action.payload,
                }}else{
                return state
            }
        }
        //работа с Единицы измерения
        case 'SET_UPDATE_UNITS': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceUnits, action.payload);
            let OldData = JSON.stringify(state.referenceUnits);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceUnits: SetUnsetDeletedListTable(action.payload),
                    referenceUnitsAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_UNITS': {
            // console.log('Сравниваем два стейта Units старый и новый ',state.referenceUnits,action.payload);
            let OldData = JSON.stringify(state.referenceUnits);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceUnits: SetUnsetDeletedListTable(action.payload),
                    referenceUnitsAll: action.payload,
                }}else{
                return state
            }
        }
        //работа с Улицы
        case 'SET_UPDATE_STREET': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceStreet, action.payload);
            let OldData = JSON.stringify(state.referenceStreet);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceStreet: SetUnsetDeletedListTable(action.payload),
                    referenceStreetAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_STREET': {
            // console.log('Сравниваем два стейта Street старый и новый ',state.referenceStreet,action.payload);
            let OldData = JSON.stringify(state.referenceStreet);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceStreet: SetUnsetDeletedListTable(action.payload),
                    referenceStreetAll: action.payload,
                }}else{
                return state
            }
        }
        //работа с Наценки
        case 'SET_UPDATE_MARKUP': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceMarkup, action.payload);
            let OldData = JSON.stringify(state.referenceMarkup);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceMarkup: SetUnsetDeletedListTable(action.payload),
                    referenceMarkupAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_MARKUP': {
            // console.log('Сравниваем два стейта Markup старый и новый ',state.referenceMarkup,action.payload);
            let OldData = JSON.stringify(state.referenceMarkup);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceMarkup: SetUnsetDeletedListTable(action.payload),
                    referenceMarkupAll: action.payload,
                }}else{
                return state
            }
        }
        //работа с Должности
        case 'SET_UPDATE_POSITIONWORKER': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referencePositionWorker, action.payload);
            let OldData = JSON.stringify(state.referencePositionWorker);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referencePositionWorker: SetUnsetDeletedListTable(action.payload),
                    referencePositionWorkerAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_POSITIONWORKER': {
            // console.log('Сравниваем два стейта PositionWorker старый и новый ',state.referencePositionWorker,action.payload);
            let OldData = JSON.stringify(state.referencePositionWorker);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referencePositionWorker: SetUnsetDeletedListTable(action.payload),
                    referencePositionWorkerAll: action.payload,
                }}else{
                return state
            }
        }
        //работа с Скидки
        case 'SET_UPDATE_DISCOUNT': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceDiscount, action.payload);
            let OldData = JSON.stringify(state.referenceDiscount);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceDiscount: SetUnsetDeletedListTable(action.payload),
                    referenceDiscountAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_DISCOUNT': {
            // console.log('Сравниваем два стейта Discount старый и новый ',state.referenceDiscount,action.payload);
            let OldData = JSON.stringify(state.referenceDiscount);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceDiscount: SetUnsetDeletedListTable(action.payload),
                    referenceDiscountAll: action.payload,
                }}else{
                return state
            }
        }
//работа с Организации
        case 'SET_UPDATE_ORGANIZATION': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceOrganization, action.payload);
            let OldData = JSON.stringify(state.referenceOrganization);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceOrganization: SetUnsetDeletedListTable(action.payload),
                    referenceOrganizationAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_ORGANIZATION': {
            // console.log('Сравниваем два стейта Organization старый и новый ',state.referenceOrganization,action.payload);
            let OldData = JSON.stringify(state.referenceOrganization);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceOrganization: SetUnsetDeletedListTable(action.payload),
                    referenceOrganizationAll: action.payload,
                }}else{
                return state
            }
        }
//работа с Сотрудники
        case 'SET_UPDATE_EMPLOYEESLIST': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceEmployeesList, action.payload);
            let OldData = JSON.stringify(state.referenceEmployeesList);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceEmployeesList: SetUnsetDeletedListTable(action.payload),
                    referenceEmployeesListAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_EMPLOYEESLIST': {
            // console.log('Сравниваем два стейта EmployeesList старый и новый ',state.referenceEmployeesList,action.payload);
            let OldData = JSON.stringify(state.referenceEmployeesList);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceEmployeesList: SetUnsetDeletedListTable(action.payload),
                    referenceEmployeesListAll: action.payload,
                }}else{
                return state
            }
        }
        //работа с User
        case 'SET_UPDATE_USERLIST': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceEmployeesList, action.payload);
            let OldData = JSON.stringify(state.referenceUserList);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceUserList: SetUnsetDeletedListTable(action.payload),
                    referenceUserListAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_USERLIST': {
            console.log('Сравниваем два стейта UserList старый и новый ',state.referenceUserList,action.payload);
            let OldData = JSON.stringify(state.referenceUserList);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceUserList: SetUnsetDeletedListTable(action.payload),
                    referenceUserListAll: action.payload,
                }}else{
                return state
            }
        }
        //работа с PromoCreate
        case 'SET_UPDATE_PROMOCREATE': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceEmployeesList, action.payload);
            let OldData = JSON.stringify(state.referencePromoCreate);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referencePromoCreate: SetUnsetDeletedListTable(action.payload),
                    referencePromoCreateAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_PROMOCREATE': {
            console.log('Сравниваем два стейта UserList старый и новый ',state.referencePromoCreate,action.payload);
            let OldData = JSON.stringify(state.referencePromoCreate);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referencePromoCreate: SetUnsetDeletedListTable(action.payload),
                    referencePromoCreateAll: action.payload,
                }}else{
                return state
            }
        }
//работа с Сертификаты
        case 'SET_UPDATE_CERTIFICATE': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referenceCertificate, action.payload);
            let OldData = JSON.stringify(state.referenceCertificate);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referenceCertificate: SetUnsetDeletedListTable(action.payload),
                    referenceCertificateAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_CERTIFICATE': {
            // console.log('Сравниваем два стейта Certificate старый и новый ',state.referenceCertificate,action.payload);
            let OldData = JSON.stringify(state.referenceCertificate);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referenceCertificate: SetUnsetDeletedListTable(action.payload),
                    referenceCertificateAll: action.payload,
                }}else{
                return state
            }
        }
//работа с Промокоды
        case 'SET_UPDATE_PROMOCODE': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.referencePromocode, action.payload);
            let OldData = JSON.stringify(state.referencePromocode);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    referencePromocode: SetUnsetDeletedListTable(action.payload),
                    referencePromocodeAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_PROMOCODE': {
            // console.log('Сравниваем два стейта Promocode старый и новый ',state.referencePromocode,action.payload);
            let OldData = JSON.stringify(state.referencePromocode);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    referencePromocode: SetUnsetDeletedListTable(action.payload),
                    referencePromocodeAll: action.payload,
                }}else{
                return state
            }
        }
//работа с Филиалы
        case 'SET_UPDATE_AFFILIATE': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.affiliate, action.payload);
            let OldData = JSON.stringify(state.affiliate);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    affiliate: SetUnsetDeletedListTable(action.payload),
                    affiliateAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_AFFILIATE': {
            // console.log('Сравниваем два стейта Affiliate старый и новый ',state.affiliate,action.payload);
            let OldData = JSON.stringify(state.affiliate);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    affiliate: SetUnsetDeletedListTable(action.payload),
                    affiliateAll: action.payload,
                }}else{
                return state
            }
        }
        //работа с ПОДАРКИ
        case 'SET_UPDATE_GIFTS': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.gifts, action.payload);
            let OldData = JSON.stringify(state.gifts);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    gifts: SetUnsetDeletedListTable(action.payload),
                    giftsAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_GIFTS': {
            // console.log('Сравниваем два стейта Gifts старый и новый ',state.gifts,action.payload);
            let OldData = JSON.stringify(state.gifts);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    gifts: SetUnsetDeletedListTable(action.payload),
                    giftsAll: action.payload,
                }}else{
                return state
            }
        }
//работа с Точки Продаж
        case 'SET_UPDATE_OUTLETS': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.outlets, action.payload);
            let OldData = JSON.stringify(state.outlets);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    outlets: SetUnsetDeletedListTable(action.payload),
                    outletsAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_OUTLETS': {
            // console.log('Сравниваем два стейта Outlets старый и новый ',state.outlets,action.payload);
            let OldData = JSON.stringify(state.outlets);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    outlets: SetUnsetDeletedListTable(action.payload),
                    outletsAll: action.payload,
                }}else{
                return state
            }
        }

//работа с Товары и категории для Склад
        case 'SET_UPDATE_CATEGORY': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.category, action.payload);
            let OldData = JSON.stringify(state.category);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    category: SetUnsetDeletedListTable(action.payload),
                    categoryAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_CATEGORY': {
            // console.log('Сравниваем два стейта category старый и новый ',state.category,action.payload);
            let OldData = JSON.stringify(state.category);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    category: SetUnsetDeletedListTable(action.payload),
                    categoryAll: action.payload,
                }}else{
                return state
            }
        }
        case 'SET_UPDATE_PRODUCT_TAGS': {
            let OldData = JSON.stringify(state.productTags);
            let NewData = JSON.stringify(action.payload);

            if (OldData !== NewData) {
                return {
                    ...state,
                    productTags: SetUnsetDeletedListTable(action.payload),
                    productTagsAll: action.payload,
                }
            } else {
                return state
            }
        }

        case 'LOAD_PRODUCT_TAGS': {
            let OldData = JSON.stringify(state.productTags);
            let NewData = JSON.stringify(action.payload);

            if(OldData !== NewData){
                return {
                    ...state,
                    productTags: SetUnsetDeletedListTable(action.payload),
                    productTagsAll: action.payload,
                }}else{
                return state
            }
        }
//работа с Таблицей Продуктов для Склад
        case 'SET_UPDATE_PRODUCTLIST': {
            // console.log('Сравниваем два стейта notes старый и новый ', state.productList, action.payload);
            let OldData = JSON.stringify(state.productList);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData, NewData);

            if (OldData !== NewData) {
                // console.log('Данные Order Source  не равны, заменяем новыми.',OldData, NewData);
                return {
                    ...state,
                    productList: SetUnsetDeletedListTable(action.payload),
                    productListAll: action.payload,
                }
            } else {
                // console.log('Данные Order Source равны.', OldData, NewData);
                return state
            }
        }

        case 'LOAD_PRODUCTLIST': {
            // console.log('Сравниваем два стейта ProductList старый и новый ',state.productList,action.payload);
            let OldData = JSON.stringify(state.productList);
            let NewData = JSON.stringify(action.payload);
            // console.log(OldData,NewData);

            if(OldData !== NewData){
                // console.log('Данные notes  не равны, заменяем новыми.');
                return {
                    ...state,
                    productList: SetUnsetDeletedListTable(action.payload),
                    productListAll: action.payload,
                }}else{
                return state
            }
        }

        case 'SET_CATALOG_LOAD_ERROR': {
            return {
                ...state,
                catalogLoadError: action.payload || null,
            }
        }


        ///УСТАНОВКА СТАТУСА ЗАГРУЗКИ ИНФОРМАЦ"ИИ С СЕРВЕРА: true - успешно загружено, false - в процессе загрузки
        case 'LOAD_STATUS_SERVER_INFO': {
            if (state.statusLoadServerInfo === action.payload) {
                return state
            }
            return {
                ...state,
                statusLoadServerInfo:action.payload
            }
        }

        case 'LOAD_DOMAIN_STATUS': {
            const domain = action.payload?.domain
            if (!domain || state[domain] === action.payload?.ready) {
                return state
            }
            return {
                ...state,
                [domain]: action.payload.ready,
            }
        }

        default: {
            return state
        }
    }
};

const SystemServerInfoContext = createContext(null);

const extractCatalogErrorPayload = (e, fallbackText) => {
    if (e && typeof e === 'object') {
        if (e.error || e.errorInfo || e.result === 'error') {
            return {
                error: e.error || 'Error Billing Feature',
                errorInfo: e.errorInfo || fallbackText,
                result: e.result || 'error',
            }
        }
        if (e.response && e.response.data && typeof e.response.data === 'object') {
            const d = e.response.data
            return {
                error: d.error || 'Client Error',
                errorInfo: d.errorInfo || d.message || fallbackText,
                result: d.result || 'error',
            }
        }
    }
    return { error: 'Client Error', errorInfo: fallbackText, result: 'error' }
}

export const SystemServerInfoProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, undefined, createInitialSystemServerInfoState);
    const [warehouseDispositionDialog, setWarehouseDispositionDialog] = useState(null)
    const warehouseDispositionResolver = useRef(null)

    const closeWarehouseDisposition = (value) => {
        const resolve = warehouseDispositionResolver.current
        warehouseDispositionResolver.current = null
        setWarehouseDispositionDialog(null)
        if (resolve) resolve(value)
    }

    const requestWarehouseDisposition = async (idOrder, idStatus, isDelete) => {
        const response = await axios.post('/api/order/warehouseDispositionPreview', { idOrder, idStatus: idStatus || 0, isDelete: Boolean(isDelete) })
        const preview = response?.data?.data || response?.data || {}
        if (!preview.required) return {}
        return new Promise((resolve) => {
            warehouseDispositionResolver.current = resolve
            setWarehouseDispositionDialog({
                preview,
                idOrder,
                idStatus: idStatus || 0,
                isDelete: Boolean(isDelete),
                idempotencyKey: `order-disposition-${idOrder}-${Date.now()}-${Math.random().toString(16).slice(2)}`,
            })
        })
    }

    // const {systemColor} = useReferenceServerInfo();
    // const {referenceNotes} = useReferenceServerInfo();


    const setUpdateSortable = async (idOld,idNew, SortsOld, SortsNew, typeDataBase)=>{
        try {
            await axios.post('/api/reference/setUpdateSortable',{
                idOld,
                idNew,
                SortsOld,
                SortsNew,
                typeDataBase
            });

            let newState =[];

            try {
                switch (typeDataBase) {
                    case "StatusOrder":
                        newState = await getALlStatusOrderServer();
                        // dispatch({
                        //     type: 'SET_UPDATE_STATUS_ORDER',
                        //     payload: newState,
                        // });
                        // setDeletedStatusOrder(0,false);

                        // console.log('При изменении сортировки получили новый спеисок статусов - ',newState);

                        return newState;
                    default:
                        // console.log('Нет информации, что именно нужно обновить, так ак пришел запрос на ',typeDataBase);
                }
            }catch (e) {
                // console.log('Ошибка при обновлении сортировки в процессе получения новых данных',e);
            }
            // dispatch({
            //     type: res.data.TYPE_REDUCER,
            //     payload: res.data.data,
            // });

            return newState;
        } catch (e) {
            console.error(e)
        }
    };


    const setActiveNotes = async (notesId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveNotes',{
                id: notesId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_NOTES',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedNotes = async (notesId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedNotes',{
                id: notesId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_NOTES',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateNotes = async (dataNotesUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateNotes',{
                dataNotesUpdate
            });
            dispatch({
                type: 'SET_UPDATE_NOTES',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewNotes = async (dataNotesUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewNotes',{
                dataNotesUpdate
            });
            dispatch({
                type: 'SET_UPDATE_NOTES',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllColorServer = async () => {
        // console.log('Заменяем state', state , "На новый стаейт ",state);
        try {
            const res = await axios.get('/api/reference/allColor');
            dispatch({
                type: 'LOAD_COLOR',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getALlNotesServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllNotes');
            dispatch({
                type: 'LOAD_NOTES',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    const setActiveOrderSource = async (OrderSourceId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveOrderSource',{
                id: OrderSourceId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_ORDER_SOURCE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedOrderSource = async (OrderSourceId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedOrderSource',{
                id: OrderSourceId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_ORDER_SOURCE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateOrderSource = async (dataOrderSourceUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateOrderSource',{
                dataOrderSourceUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_ORDER_SOURCE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewOrderSource = async (dataOrderSourceUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewOrderSource',{
                dataOrderSourceUpdate
            });
            dispatch({
                type: 'SET_UPDATE_ORDER_SOURCE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getALlOrderSourceServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllOrderSource');
            dispatch({
                type: 'LOAD_ORDER_SOURCE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setActiveStatusOrder = async (StatusOrderId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveStatusOrder',{
                id: StatusOrderId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_STATUS_ORDER',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedStatusOrder = async (StatusOrderId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedStatusOrder',{
                id: StatusOrderId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_STATUS_ORDER',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setUpdateStatusOrder = async (dataStatusOrderUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateStatusOrder',{
                dataStatusOrderUpdate
            });
            dispatch({
                type: 'SET_UPDATE_STATUS_ORDER',
                payload: res.data,
            });
            return res.data;
        } catch (e) {
            console.error(e)
            return e?.response?.data || { error: true, message: e?.message || 'Не удалось сохранить статус' }
        }
    };


    const setSaveNewStatusOrder = async (dataStatusOrderUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewStatusOrder',{
                dataStatusOrderUpdate
            });
            dispatch({
                type: 'SET_UPDATE_STATUS_ORDER',
                payload: res.data,
            });
            return res.data;
        } catch (e) {
            console.error(e)
            return e?.response?.data || { error: true, message: e?.message || 'Не удалось создать статус' }
        }
    };

    const getALlStatusOrderServer = async () => {
        // console.log('Все работает, ну должно');
        try {
            const res = await axios.get('/api/reference/getAllStatusOrder');
            dispatch({
                type: 'LOAD_STATUS_ORDER',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


///WRITEOFF Ниже
    const setActiveWriteOff = async (WriteOffId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveWriteOff',{
                id: WriteOffId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_WRITE_OFF',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedWriteOff = async (WriteOffId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedWriteOff',{
                id: WriteOffId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_WRITE_OFF',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateWriteOff = async (dataWriteOffUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateWriteOff',{
                dataWriteOffUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_WRITE_OFF',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewWriteOff = async (dataWriteOffUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewWriteOff',{
                dataWriteOffUpdate
            });
            dispatch({
                type: 'SET_UPDATE_WRITE_OFF',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getALlWriteOffServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllWriteOff');
            dispatch({
                type: 'LOAD_WRITE_OFF',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// TYPEPAYMENTS ниже
    const setActiveTypePayments = async (TypePaymentsId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveTypePayments',{
                id: TypePaymentsId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_TYPE_PAYMENTS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedTypePayments = async (TypePaymentsId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedTypePayments',{
                id: TypePaymentsId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_TYPE_PAYMENTS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateTypePayments = async (dataTypePaymentsUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateTypePayments',{
                dataTypePaymentsUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_TYPE_PAYMENTS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewTypePayments = async (dataTypePaymentsUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewTypePayments',{
                dataTypePaymentsUpdate
            });
            dispatch({
                type: 'SET_UPDATE_TYPE_PAYMENTS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getALlTypePaymentsServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllTypePayments');
            dispatch({
                type: 'LOAD_TYPE_PAYMENTS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// ALLCHANGELIST ниже
    const setActiveChangeList = async (ChangeListId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveChangeList',{
                id: ChangeListId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_CHANGELIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedChangeList = async (ChangeListId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedChangeList',{
                id: ChangeListId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_CHANGELIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateChangeList = async (dataChangeListUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateChangeList',{
                dataChangeListUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_CHANGELIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewChangeList = async (dataChangeListUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewChangeList',{
                dataChangeListUpdate
            });
            dispatch({
                type: 'SET_UPDATE_CHANGELIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllChangeListServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllChangeList');
            dispatch({
                type: 'LOAD_CHANGELIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// MARKS ниже
    const setActiveMarks = async (MarksId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveMarks',{
                id: MarksId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_MARKS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedMarks = async (MarksId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedMarks',{
                id: MarksId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_MARKS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateMarks = async (dataMarksUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateMarks',{
                dataMarksUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_MARKS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewMarks = async (dataMarksUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewMarks',{
                dataMarksUpdate
            });
            dispatch({
                type: 'SET_UPDATE_MARKS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllMarksServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllMarks');
            dispatch({
                type: 'LOAD_MARKS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// UNITS ниже
    const setActiveUnits = async (UnitsId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveUnits',{
                id: UnitsId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_UNITS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedUnits = async (UnitsId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedUnits',{
                id: UnitsId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_UNITS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateUnits = async (dataUnitsUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateUnits',{
                dataUnitsUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_UNITS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewUnits = async (dataUnitsUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewUnits',{
                dataUnitsUpdate
            });
            dispatch({
                type: 'SET_UPDATE_UNITS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllUnitsServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllUnits');
            dispatch({
                type: 'LOAD_UNITS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// SUPPLIERS ниже
    const setActiveSuppliers = async (SuppliersId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveSuppliers',{
                id: SuppliersId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_SUPPLIERS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedSuppliers = async (SuppliersId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedSuppliers',{
                id: SuppliersId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_SUPPLIERS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateSuppliers = async (dataSuppliersUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateSuppliers',{
                dataSuppliersUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_SUPPLIERS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewSuppliers = async (dataSuppliersUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewSuppliers',{
                dataSuppliersUpdate
            });
            dispatch({
                type: 'SET_UPDATE_SUPPLIERS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllSuppliersServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllSuppliers');
            dispatch({
                type: 'LOAD_SUPPLIERS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// STREET ниже
    const setActiveStreet = async (StreetId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveStreet',{
                id: StreetId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_STREET',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedStreet = async (StreetId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedStreet',{
                id: StreetId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_STREET',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateStreet = async (dataStreetUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateStreet',{
                dataStreetUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_STREET',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewStreet = async (dataStreetUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewStreet',{
                dataStreetUpdate
            });
            dispatch({
                type: 'SET_UPDATE_STREET',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllStreetServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllStreet');
            dispatch({
                type: 'LOAD_STREET',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// MARKUP ниже
    const setActiveMarkup = async (MarkupId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveMarkup',{
                id: MarkupId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_MARKUP',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedMarkup = async (MarkupId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedMarkup',{
                id: MarkupId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_MARKUP',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateMarkup = async (dataMarkupUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateMarkup',{
                dataMarkupUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_MARKUP',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewMarkup = async (dataMarkupUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewMarkup',{
                dataMarkupUpdate
            });
            dispatch({
                type: 'SET_UPDATE_MARKUP',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllMarkupServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllMarkup');
            dispatch({
                type: 'LOAD_MARKUP',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// POSITIONWORKER ниже
    const setActivePositionWorker = async (PositionWorkerId, value) => {
        try {
            const res = await axios.post('/api/reference/setActivePositionWorker',{
                id: PositionWorkerId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_POSITIONWORKER',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedPositionWorker = async (PositionWorkerId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedPositionWorker',{
                id: PositionWorkerId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_POSITIONWORKER',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdatePositionWorker = async (dataPositionWorkerUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdatePositionWorker',{
                dataPositionWorkerUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_POSITIONWORKER',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewPositionWorker = async (dataPositionWorkerUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewPositionWorker',{
                dataPositionWorkerUpdate
            });
            dispatch({
                type: 'SET_UPDATE_POSITIONWORKER',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllPositionWorkerServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllPositionWorker');
            dispatch({
                type: 'LOAD_POSITIONWORKER',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// DISCOUNT ниже
    const setActiveDiscount = async (DiscountId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveDiscount',{
                id: DiscountId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_DISCOUNT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedDiscount = async (DiscountId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedDiscount',{
                id: DiscountId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_DISCOUNT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateDiscount = async (dataDiscountUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateDiscount',{
                dataDiscountUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_DISCOUNT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewDiscount = async (dataDiscountUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewDiscount',{
                dataDiscountUpdate
            });
            dispatch({
                type: 'SET_UPDATE_DISCOUNT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllDiscountServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllDiscount');
            dispatch({
                type: 'LOAD_DISCOUNT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// ORGANIZATION ниже
    const setActiveOrganization = async (OrganizationId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveOrganization',{
                id: OrganizationId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_ORGANIZATION',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedOrganization = async (OrganizationId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedOrganization',{
                id: OrganizationId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_ORGANIZATION',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateOrganization = async (dataOrganizationUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateOrganization',{
                dataOrganizationUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_ORGANIZATION',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewOrganization = async (dataOrganizationUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewOrganization',{
                dataOrganizationUpdate
            });
            dispatch({
                type: 'SET_UPDATE_ORGANIZATION',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllOrganizationServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllOrganization');
            dispatch({
                type: 'LOAD_ORGANIZATION',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// EMPLOYEESLIST ниже
    const setActiveEmployeesList = async (EmployeesListId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveEmployees',{
                id: EmployeesListId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_EMPLOYEESLIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedEmployeesList = async (EmployeesListId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedEmployees',{
                id: EmployeesListId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_EMPLOYEESLIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateEmployeesList = async (dataEmployeesUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateEmployees',{
                dataEmployeesUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_EMPLOYEESLIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewEmployeesList = async (dataEmployeesUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewEmployees',{
                dataEmployeesUpdate
            });
            dispatch({
                type: 'SET_UPDATE_EMPLOYEESLIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllEmployeesListServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllEmployees');
            dispatch({
                type: 'LOAD_EMPLOYEESLIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// UserList ниже
    const setActiveUserList = async (UserListId, value) => {
        try {
            const res = await axios.post('/api/user/setActiveUser',{
                id: UserListId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_USERLIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedUserList = async (UserListId, value) => {
        try {
            const res = await axios.post('/api/user/setDeletedUser',{
                id: UserListId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_USERLIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateUserList = async (dataUserUpdate) => {
        try {
            const res = await axios.post('/api/user/setUpdateUser',{
                dataUserUpdate
            });
            console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_USERLIST',
                payload: res.data.userList,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewUserList = async (dataUserUpdate) => {
        try {
            const res = await axios.post('/api/user/setNewUser',{
                dataUserUpdate
            });
            dispatch({
                type: 'SET_UPDATE_USERLIST',
                payload: res.data.userList,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllUserListServer = async () => {
        // console.log('getAllUserList запустили')
        try {
            const res = await axios.get('/api/user/getUserList');
            dispatch({
                type: 'LOAD_USERLIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// PromoCreate ниже
    const setActivePromoCreate = async (UserListId, value) => {
        try {
            const res = await axios.post('/api/marketing/setActivePromoCreate',{
                id: UserListId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_PROMOCREATE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedPromoCreate = async (UserListId, value) => {
        try {
            const res = await axios.post('/api/marketing/setDeletedPromoCreate',{
                id: UserListId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_PROMOCREATE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdatePromoCreate = async (dataUserUpdate) => {
        try {
            const res = await axios.post('/api/marketing/setUpdatePromoCreate',{
                dataUpdate: dataUserUpdate
            });
            console.log('Вернулся ответ сервера',res);
            const freshPayload = await getAllPromoCreateListServer();
            let promoCreatePayload = freshPayload;
            const isPayloadValid = Array.isArray(promoCreatePayload)
                || (promoCreatePayload && (Array.isArray(promoCreatePayload?.promocode_list) || Array.isArray(promoCreatePayload?.category_promocode)));
            if (!isPayloadValid) {
                promoCreatePayload = res.data?.promoCreateList || [];
            }
            dispatch({
                type: 'SET_UPDATE_PROMOCREATE',
                payload: promoCreatePayload,
            });

            return {
                ...res.data,
                promoCreateList: promoCreatePayload,
                result: typeof res.data?.result !== 'undefined' ? res.data.result : isPayloadValid,
                error: typeof res.data?.error !== 'undefined' ? res.data.error : !isPayloadValid,
            };
        } catch (e) {
            console.error(e)
            return {
                error: true,
                message: e?.response?.data?.message || e?.message || 'Ошибка обновления промокода',
            };
        }
    };


    const setSaveNewPromoCreate = async (dataUserUpdate) => {
        try {
            const res = await axios.post('/api/marketing/setNewPromoCreate',{
                dataUpdate: dataUserUpdate
            });
            const freshPayload = await getAllPromoCreateListServer();
            let promoCreatePayload = freshPayload;
            const isPayloadValid = Array.isArray(promoCreatePayload)
                || (promoCreatePayload && (Array.isArray(promoCreatePayload?.promocode_list) || Array.isArray(promoCreatePayload?.category_promocode)));
            if (!isPayloadValid) {
                promoCreatePayload = res.data?.promoCreateList || [];
            }
            dispatch({
                type: 'SET_UPDATE_PROMOCREATE',
                payload: promoCreatePayload,
            });

            return {
                ...res.data,
                promoCreateList: promoCreatePayload,
                result: typeof res.data?.result !== 'undefined' ? res.data.result : isPayloadValid,
                error: typeof res.data?.error !== 'undefined' ? res.data.error : !isPayloadValid,
            };
        } catch (e) {
            console.error(e);
            return {
                error: true,
                message: e?.response?.data?.message || e?.message || 'Ошибка сохранения промокода',
            };
        }
    };

    const setUpdatePromoCreateCategory = async (dataCategoryUpdate) => {
        try {
            const res = await axios.post('/api/marketing/setUpdatePromocodeForCategory', {
                dataPromocodeForCategoryUpdate: dataCategoryUpdate
            });
            const freshPayload = await getAllPromoCreateListServer();
            const promoCreatePayload = freshPayload || res.data?.promoCreateList || [];
            dispatch({
                type: 'SET_UPDATE_PROMOCREATE',
                payload: promoCreatePayload,
            });
            return res.data;
        } catch (e) {
            console.error(e);
            return { error: true, message: e?.response?.data?.message || e?.message || 'Ошибка обновления категории промокодов' };
        }
    };

    const setDeletedPromoCreateCategory = async (categoryId, value) => {
        try {
            const res = await axios.post('/api/marketing/setPromocodeForCategoryDeleted', {
                id: categoryId,
                val: value
            });
            const freshPayload = await getAllPromoCreateListServer();
            const promoCreatePayload = freshPayload || res.data?.promoCreateList || [];
            dispatch({
                type: 'SET_UPDATE_PROMOCREATE',
                payload: promoCreatePayload,
            });
            return res.data;
        } catch (e) {
            console.error(e);
            return { error: true, message: e?.response?.data?.message || e?.message || 'Ошибка удаления категории промокодов' };
        }
    };

    const setSaveNewPromoCreateCategory = async (dataCategoryInsert) => {
        try {
            const res = await axios.post('/api/marketing/setSaveNewPromocodeForCategory', {
                dataPromocodeForCategoryInsert: dataCategoryInsert
            });
            const freshPayload = await getAllPromoCreateListServer();
            const promoCreatePayload = freshPayload || res.data?.promoCreateList || [];
            dispatch({
                type: 'SET_UPDATE_PROMOCREATE',
                payload: promoCreatePayload,
            });
            return res.data;
        } catch (e) {
            console.error(e);
            return { error: true, message: e?.response?.data?.message || e?.message || 'Ошибка создания категории промокодов' };
        }
    };

    const getAllPromoCreateListServer = async () => {
        // console.log('getAllUserList запустили')
        try {
            const res = await axios.get('/api/marketing/getPromoCreateList');
            const promoCreatePayload = res.data?.promoCreateList || res.data || [];
            dispatch({
                type: 'LOAD_PROMOCREATE',
                payload: promoCreatePayload,
            });

            return promoCreatePayload;
        } catch (e) {
            console.error(e)
        }
    };
/// CERTIFICATE ниже
    const setActiveCertificate = async (CertificateId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveCertificate',{
                id: CertificateId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_CERTIFICATE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedCertificate = async (CertificateId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedCertificate',{
                id: CertificateId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_CERTIFICATE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateCertificate = async (dataCertificateUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateCertificate',{
                dataCertificateUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_CERTIFICATE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewCertificate = async (dataCertificateUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewCertificate',{
                dataCertificateUpdate
            });
            dispatch({
                type: 'SET_UPDATE_CERTIFICATE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllCertificateServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllCertificate');
            dispatch({
                type: 'LOAD_CERTIFICATE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
/// PROMOCODE ниже
    const setActivePromocode = async (PromocodeId, value) => {
        try {
            const res = await axios.post('/api/reference/setActivePromocode',{
                id: PromocodeId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_PROMOCODE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedPromocode = async (PromocodeId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedPromocode',{
                id: PromocodeId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_PROMOCODE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdatePromocode = async (dataPromocodeUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdatePromocode',{
                dataPromocodeUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_PROMOCODE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewPromocode = async (dataPromocodeUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewPromocode',{
                dataPromocodeUpdate
            });
            dispatch({
                type: 'SET_UPDATE_PROMOCODE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllPromocodeServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllPromocode');
            dispatch({
                type: 'LOAD_PROMOCODE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
/// AFFILIATE ниже
    const setActiveAffiliate = async (AffiliateId, value) => {
        try {
            const res = await axios.post('/api/affiliate/setActiveAffiliate',{
                id: AffiliateId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_AFFILIATE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedAffiliate = async (AffiliateId, value) => {
        try {
            const res = await axios.post('/api/affiliate/setDeletedAffiliate',{
                id: AffiliateId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_AFFILIATE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateAffiliate = async (dataAffiliateUpdate) => {
        try {
            const res = await axios.post('/api/affiliate/setUpdateAffiliate',{
                dataAffiliateUpdate
            });
            const payload = res?.data;
            const list = Array.isArray(payload) ? payload : (Array.isArray(payload?.data) ? payload.data : null);
            if (Array.isArray(list)) {
                dispatch({
                    type: 'SET_UPDATE_AFFILIATE',
                    payload: list,
                });
                return list;
            }
            return payload;
        } catch (e) {
            console.error(e)
            return { error: true, errorInfo: e?.message || 'Ошибка обновления филиала' };
        }
    };


    const setSaveNewAffiliate = async (dataAffiliateUpdate) => {
        try {
            const res = await axios.post('/api/affiliate/setSaveNewAffiliate',{
                dataAffiliateUpdate
            });
            if (!Array.isArray(res.data)) {
                return { error: true, errorInfo: res.data?.errorInfo || 'Сервер не подтвердил создание филиала' };
            }
            dispatch({
                type: 'SET_UPDATE_AFFILIATE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
            return { error: true, errorInfo: e?.response?.data?.errorInfo || e?.errorInfo || 'Не удалось сохранить филиал. Проверьте соединение и обновите список перед повторной попыткой.' };
        }
    };

    const getAllAffiliateServer = async () => {
        try {
            const res = await axios.get('/api/affiliate/getAllAffiliate');
            dispatch({
                type: 'LOAD_AFFILIATE',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// GIFTS ниже
    const setActiveGifts = async (GiftsId, value) => {
        try {
            const res = await axios.post('/api/marketing/setActiveGifts',{
                id: GiftsId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_GIFTS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedGifts = async (GiftsId, value) => {
        try {
            const res = await axios.post('/api/marketing/setDeletedGifts',{
                id: GiftsId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_GIFTS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateGifts = async (dataGiftsUpdate) => {
        try {
            const res = await axios.post('/api/marketing/setUpdateGifts',{
                dataGiftsUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_GIFTS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewGifts = async (dataGiftsUpdate) => {
        try {
            const res = await axios.post('/api/marketing/setSaveNewGifts',{
                dataGiftsUpdate
            });
            dispatch({
                type: 'SET_UPDATE_GIFTS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllGiftsServer = async () => {
        try {
            const res = await axios.get('/api/marketing/getAllGifts');
            dispatch({
                type: 'LOAD_GIFTS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
/// OUTLETS ниже
    const setActiveOutlets = async (OutletsId, value) => {
        try {
            const res = await axios.post('/api/outlets/setActiveOutlets',{
                id: OutletsId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_OUTLETS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedOutlets = async (OutletsId, value) => {
        try {
            const res = await axios.post('/api/outlets/setDeletedOutlets',{
                id: OutletsId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_OUTLETS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateOutlets = async (dataOutletsUpdate) => {
        try {
            const res = await axios.post('/api/outlets/setUpdateOutlets',{
                dataOutletsUpdate
            });
            const payload = res?.data;
            const list = Array.isArray(payload) ? payload : (Array.isArray(payload?.data) ? payload.data : null);
            if (Array.isArray(list)) {
                dispatch({
                    type: 'SET_UPDATE_OUTLETS',
                    payload: list,
                });
                return list;
            }
            return payload;
        } catch (e) {
            console.error(e)
            return { error: true, errorInfo: e?.message || 'Ошибка обновления точки' };
        }
    };


    const setSaveNewOutlets = async (dataOutletsUpdate) => {
        try {
            const res = await axios.post('/api/outlets/setSaveNewOutlets',{
                dataOutletsUpdate
            });
            dispatch({
                type: 'SET_UPDATE_OUTLETS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllOutletsServer = async () => {
        try {
            const res = await axios.get('/api/outlets/getAllOutlets');
            dispatch({
                type: 'LOAD_OUTLETS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

/// CATEGORY для склад ниже
    const setActiveCategory = async (CategoryId, value) => {
        try {
            const res = await axios.post('/api/catalog/setActiveCategory',{
                id: CategoryId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_CATEGORY',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedCategory = async (CategoryId, value) => {
        try {
            const res = await axios.post('/api/catalog/setDeletedCategory',{
                id: CategoryId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_CATEGORY',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateCategory = async (dataCategoryUpdate) => {
        try {
            const res = await axios.post('/api/catalog/setUpdateCategory',{
                dataCategoryUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_CATEGORY',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    const generateCategoryProductArticles = async (categoryId, mode = 'fill_empty') => {
        try {
            const res = await axios.post('/api/catalog/generateCategoryProductArticles', {
                category_id: Number(categoryId) || 0,
                mode: mode === 'overwrite' ? 'overwrite' : 'fill_empty',
            });
            const result = res?.data?.data || res?.data || {};
            await getAllProductListServer();
            return result;
        } catch (e) {
            const payload = getApiErrorPayload(e, 'Ошибка массовой генерации артикулов');
            console.error('[catalog][ctx] generateCategoryProductArticles error', payload);
            return {
                ...payload,
                __error: true,
            };
        }
    };
    const setUpdateCategorySortable = async (dataCategoryUpdateSortable) => {
        try {
            const res = await axios.post('/api/catalog/setUpdateCategorySortable',{
                dataCategoryUpdateSortable
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_CATEGORY',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewCategory = async (dataCategoryUpdate) => {
        try {
            const res = await axios.post('/api/catalog/setSaveNewCategory',{
                dataCategoryUpdate
            });
            dispatch({
                type: 'SET_UPDATE_CATEGORY',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllCategoryServer = async () => {
        try {
            const res = await axios.get('/api/catalog/getAllCategory');
            console.log('[catalog][ctx] getAllCategoryServer success', {
                isArray: Array.isArray(res?.data),
                length: Array.isArray(res?.data) ? res.data.length : -1,
                sample: Array.isArray(res?.data) ? res.data.slice(0, 2) : res?.data,
            });
            dispatch({
                type: 'SET_CATALOG_LOAD_ERROR',
                payload: null,
            });
            dispatch({
                type: 'LOAD_CATEGORY',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
            const payload = extractCatalogErrorPayload(e, 'Ошибка загрузки категорий')
            console.warn('[catalog][ctx] getAllCategoryServer error', payload);
            dispatch({
                type: 'LOAD_CATEGORY',
                payload: [],
            });
            dispatch({
                type: 'SET_CATALOG_LOAD_ERROR',
                payload,
            });
            return []
        }
    };
    const setActiveProductTag = async (ProductTagId, value) => {
        try {
            const res = await axios.post('/api/catalog/setActiveProductTag',{
                id: ProductTagId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_PRODUCT_TAGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedProductTag = async (ProductTagId, value) => {
        try {
            const res = await axios.post('/api/catalog/setDeletedProductTag',{
                id: ProductTagId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_PRODUCT_TAGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setUpdateProductTag = async (dataProductTagUpdate) => {
        try {
            const res = await axios.post('/api/catalog/setUpdateProductTag',{
                dataProductTagUpdate
            });
            dispatch({
                type: 'SET_UPDATE_PRODUCT_TAGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setSaveNewProductTag = async (dataProductTagUpdate) => {
        try {
            const res = await axios.post('/api/catalog/setSaveNewProductTag',{
                dataProductTagUpdate
            });
            dispatch({
                type: 'SET_UPDATE_PRODUCT_TAGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllProductTagsServer = async () => {
        try {
            const res = await axios.get('/api/catalog/getAllProductTags');
            dispatch({
                type: 'LOAD_PRODUCT_TAGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
            dispatch({
                type: 'LOAD_PRODUCT_TAGS',
                payload: [],
            });
            return []
        }
    };
/// PODUCTLIST для склад ниже
    const setActiveProductList = async (ProductListId, value) => {
        try {
            const res = await axios.post('/api/catalog/setActiveProductList',{
                id: ProductListId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_PRODUCTLIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedProductList = async (ProductListId, value) => {
        try {
            const res = await axios.post('/api/catalog/setDeletedProductList',{
                id: ProductListId,
                val:value
            });
            if (res?.data?.__error || res?.data?.error || res?.data?.result === 'error') {
                return res.data;
            }
            dispatch({
                type: 'SET_UPDATE_PRODUCTLIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateProductList = async (dataProductListUpdate) => {
        // console.log('нужно отправить на сервер по ajax',dataProductListUpdate);
        try {
            const res = await axios.post('/api/catalog/setUpdateProductList',{
                    dataProductListUpdate
                }
            );
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_PRODUCTLIST',
                payload: res.data,
            });
            return res;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateProductListImg = async (fileImg) => {
        try {
            const resImg = await axios.post('/api/catalog/setUpdateProductListImg',
                fileImg
                ,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'content-type': 'multipart/form-data'
                    }
                });

            // console.log('resImg вернул вот это ',resImg);

            if(!resImg.data.error){
                return resImg.data;
            }else{
                return resImg.data;
            }

            // return res;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewProductList = async (dataProductListUpdate) => {
        try {
            const res = await axios.post('/api/catalog/setSaveNewProductList',{
                dataProductListUpdate
            });
            dispatch({
                type: 'SET_UPDATE_PRODUCTLIST',
                payload: res.data,
            });

            return res;
        } catch (e) {
            console.error(e)
        }
    };

    const getAllProductListServer = async () => {
        try {
            const res = await axios.get('/api/catalog/getAllProductList');
            dispatch({
                type: 'LOAD_PRODUCTLIST',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
            const payload = extractCatalogErrorPayload(e, 'Ошибка загрузки товаров')
            console.warn('[catalog][ctx] getAllProductListServer error', payload);
            dispatch({
                type: 'LOAD_PRODUCTLIST',
                payload: [],
            });
            dispatch({
                type: 'SET_CATALOG_LOAD_ERROR',
                payload,
            });
            return []
        }
    };
    /// SELFWRITINGS ниже
    const setActiveSelfWriting = async (SelfWritingId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveSelfWriting',{
                id: SelfWritingId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_SELFWRITINGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedSelfWriting = async (SelfWritingId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedSelfWriting',{
                id: SelfWritingId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_SELFWRITINGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateSelfWriting = async (dataSelfWritingUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateSelfWriting',{
                dataSelfWritingUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_SELFWRITINGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewSelfWriting = async (dataSelfWritingUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewSelfWriting',{
                dataSelfWritingUpdate
            });
            dispatch({
                type: 'SET_UPDATE_SELFWRITINGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getALlSelfWritingServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllSelfWriting');
            dispatch({
                type: 'LOAD_SELFWRITINGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// WRITINGS ниже
    const setActiveWriting = async (WritingId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveWriting',{
                id: WritingId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_WRITINGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedWriting = async (WritingId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedWriting',{
                id: WritingId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_WRITINGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateWriting = async (dataWritingUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateWriting',{
                dataWritingUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_WRITINGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewWriting = async (dataWritingUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewWriting',{
                dataWritingUpdate
            });
            dispatch({
                type: 'SET_UPDATE_WRITINGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getALlWritingServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllWriting');
            dispatch({
                type: 'LOAD_WRITINGS',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// MOVING ниже
    const setActiveMoving = async (MovingId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveMoving',{
                id: MovingId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_MOVING',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedMoving = async (MovingId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedMoving',{
                id: MovingId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_MOVING',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateMoving = async (dataMovingUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateMoving',{
                dataMovingUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_MOVING',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewMoving = async (dataMovingUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewMoving',{
                dataMovingUpdate
            });
            dispatch({
                type: 'SET_UPDATE_MOVING',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getALlMovingServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllMoving');
            dispatch({
                type: 'LOAD_MOVING',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// CONSIGNMENT ниже
    const setActiveConsignment = async (ConsignmentId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveConsignment',{
                id: ConsignmentId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_CONSIGNMENT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedConsignment = async (ConsignmentId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedConsignment',{
                id: ConsignmentId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_CONSIGNMENT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateConsignment = async (dataConsignmentUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateConsignment',{
                dataConsignmentUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_CONSIGNMENT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewConsignment = async (dataConsignmentUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewConsignment',{
                dataConsignmentUpdate
            });
            dispatch({
                type: 'SET_UPDATE_CONSIGNMENT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getALlConsignmentServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllConsignment');
            dispatch({
                type: 'LOAD_CONSIGNMENT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// OUTPUT ниже
    const setActiveOutput = async (OutputId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveOutput',{
                id: OutputId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_OUTPUT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedOutput = async (OutputId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedOutput',{
                id: OutputId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_OUTPUT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateOutput = async (dataOutputUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateOutput',{
                dataOutputUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_OUTPUT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewOutput = async (dataOutputUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewOutput',{
                dataOutputUpdate
            });
            dispatch({
                type: 'SET_UPDATE_OUTPUT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getALlOutputServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllOutput');
            dispatch({
                type: 'LOAD_OUTPUT',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };
    /// STOCKTAKING ниже
    const setActiveStocktaking = async (StocktakingId, value) => {
        try {
            const res = await axios.post('/api/reference/setActiveStocktaking',{
                id: StocktakingId,
                val:value
            });
            dispatch({
                type: 'SET_ACTION_STOCKTAKING',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const setDeletedStocktaking = async (StocktakingId, value) => {
        try {
            const res = await axios.post('/api/reference/setDeletedStocktaking',{
                id: StocktakingId,
                val:value
            });
            dispatch({
                type: 'SET_UPDATE_STOCKTAKING',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };



    const setUpdateStocktaking = async (dataStocktakingUpdate) => {
        try {
            const res = await axios.post('/api/reference/setUpdateStocktaking',{
                dataStocktakingUpdate
            });
            // console.log('Вернулся ответ сервера',res);
            dispatch({
                type: 'SET_UPDATE_STOCKTAKING',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setSaveNewStocktaking = async (dataStocktakingUpdate) => {
        try {
            const res = await axios.post('/api/reference/setSaveNewStocktaking',{
                dataStocktakingUpdate
            });
            dispatch({
                type: 'SET_UPDATE_STOCKTAKING',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };

    const getALlStocktakingServer = async () => {
        try {
            const res = await axios.get('/api/reference/getAllStocktaking');
            dispatch({
                type: 'LOAD_STOCKTAKING',
                payload: res.data,
            });

            return res.data;
        } catch (e) {
            console.error(e)
        }
    };


    const setStatusLoadServerInfo = async ()=>{
        dispatch({
            type: 'LOAD_STATUS_SERVER_INFO',
            payload: true,
        })
    };


    const setNewOrder = async (newOrderData)=>{
        try {
            const res = await axios.post('/api/order/newOrder',{
                newOrderData
            });
            // dispatch({
            //     type: 'LOAD_PRODUCTLIST',
            //     payload: res.data,
            // });

            return res.data;
        } catch (e) {
            console.error(e)
            return e?.response?.data || { result: 'error', error: 'Client Error', errorInfo: e?.message || 'Ошибка создания заказа' }
        }
    };


    const setEditOrder = async (EditOrderData)=>{
        try {
            const res = await axios.post('/api/order/EditOrderData',{
                EditOrderData
            });
            // dispatch({
            //     type: 'LOAD_PRODUCTLIST',
            //     payload: res.data,
            // });

            return res.data;
        } catch (e) {
            console.error(e)
            return e?.response?.data || { result: 'error', error: 'Client Error', errorInfo: e?.message || 'Ошибка обновления заказа' }
        }
    };

    const deletedOrderUser = async (idOrderDeleted)=>{
        try {
            const warehouseDisposition = await requestWarehouseDisposition(idOrderDeleted, 0, true)
            if (warehouseDisposition === false) return { result: 'canceled', message: 'Удаление отменено пользователем' }
            const res = await axios.post('/api/order/deleteOrder',{
                idOrderDeleted,
                warehouseDisposition: warehouseDisposition.action ? warehouseDisposition : undefined,
            });
            // dispatch({
            //     type: 'LOAD_PRODUCTLIST',
            //     payload: res.data,
            // });

            return res.data;
        } catch (e) {
            console.error('Delete order request failed', e?.response?.status || e?.message || 'unknown')
            return e?.response?.data || { result: 'error', error: 'Client Error', errorInfo: e?.message || 'Ошибка удаления заказа' }
        }
    };

    const setStatusOrderUser = async (idOrder,idStatus)=>{
        try {
            const warehouseDisposition = await requestWarehouseDisposition(idOrder, idStatus, false)
            if (warehouseDisposition === false) return { result: 'canceled', message: 'Смена статуса отменена пользователем' }
            const res = await axios.post('/api/order/setStatusOrder',{
                idOrder,
                idStatus,
                warehouseDisposition: warehouseDisposition.action ? warehouseDisposition : undefined,
            });
            // dispatch({
            //     type: 'LOAD_PRODUCTLIST',
            //     payload: res.data,
            // });

            return res.data;
        } catch (e) {
            console.error('Set order status request failed', e?.response?.status || e?.message || 'unknown')
            return e?.response?.data || { result: 'error', error: 'Client Error', errorInfo: e?.message || 'Ошибка смены статуса' }
        }
    };

    const setWorkerOrderUser = async (idOrder,idStatus, idWorker)=>{
        try {
            const res = await axios.post('/api/order/setWorkerStatusOrder',{
                idOrder,
                idStatus,
                idWorker
            });
            // dispatch({
            //     type: 'LOAD_PRODUCTLIST',
            //     payload: res.data,
            // });

            return res.data;
        } catch (e) {
            console.error(e)
            return e?.response?.data || { result: 'error', error: 'Client Error', errorInfo: e?.message || 'Ошибка назначения сотрудника' }
        }
    };

    const setTypePaymentOrder = async (idOrder,idPayment,textTypePayment)=>{
        try {
            const res = await axios.post('/api/order/setTypePayment',{
                idOrder,
                idPayment,
                textTypePayment
            });
            // dispatch({
            //     type: 'LOAD_PRODUCTLIST',
            //     payload: res.data,
            // });

            return res.data;
        } catch (e) {
            console.error(e)
            return e?.response?.data || { result: 'error', error: 'Client Error', errorInfo: e?.message || 'Ошибка смены типа оплаты' }
        }
    };


    useEffect(() => {
        let cancelled = false

        const loadDomain = async (domain, loaders) => {
            await Promise.all(loaders.map((loader) =>
                Promise.resolve()
                    .then(loader)
                    .catch((error) => {
                        console.error(`[server-info] ${domain} load error`, error)
                        return []
                    })
            ))

            if (!cancelled) {
                dispatch({
                    type: 'LOAD_DOMAIN_STATUS',
                    payload: { domain, ready: true },
                })
            }
        }

        (async ()=> {
            await Promise.all([
                loadDomain('catalogReady', [
                    getAllColorServer,
                    getAllUnitsServer,
                    getAllAffiliateServer,
                    getAllOutletsServer,
                    getAllCategoryServer,
                    getAllProductTagsServer,
                    getAllProductListServer,
                ]),
                loadDomain('orderReferencesReady', [
                    getALlNotesServer,
                    getAllPositionWorkerServer,
                    getALlOrderSourceServer,
                    getALlStatusOrderServer,
                    getALlWriteOffServer,
                    getALlTypePaymentsServer,
                    getAllChangeListServer,
                    getAllMarksServer,
                    getAllSuppliersServer,
                    getAllStreetServer,
                    getAllMarkupServer,
                    getAllDiscountServer,
                    getAllPromocodeServer,
                    getAllGiftsServer,
                ]),
                loadDomain('adminReferencesReady', [
                    getAllOrganizationServer,
                    getAllEmployeesListServer,
                    getAllUserListServer,
                    getAllCertificateServer,
                ]),
            ])

            // Общий флаг сохраняем для старых экранов: они откроются только
            // после завершения всех обязательных групп.
            if (!cancelled) {
                await setStatusLoadServerInfo();
            }
            // setInterval(async ()=>{
            //     let dataServer = await getAllColorServer();
            //     let dataServerNotes = await getALlNotesServer();
            //
            //     console.log('данные с сервера ',state, dataServer,dataServerNotes);
            // },10000);

            // setInterval(async ()=>{
            //     let dataServerAllChangeList = await getAllChangeListServer();
            //     // console.log('данные с сервера ',dataServerAllChangeListOne);
            // },10000);
        })()

        return () => {
            cancelled = true
        }
    }, []);

    const contextValue = {
                systemColor: state.systemColor,
                referenceNotes: state.referenceNotes,
                referenceNotesAll: state.referenceNotesAll,
                refererNotesNew: state.refererNotesNew,
                referenceOrderSource: state.referenceOrderSource,
                referenceOrderSourceAll: state.referenceOrderSourceAll,
                refererOrderSourceNew: state.refererOrderSourceNew,
                referenceStatusOrder: state.referenceStatusOrder,
                referenceStatusOrderAll: state.referenceStatusOrderAll,
                refererStatusOrderNew: state.refererStatusOrderNew,
                referenceWriteOff: state.referenceWriteOff,
                referenceWriteOffAll: state.referenceWriteOffAll,
                refererWriteOffNew: state.refererWriteOffNew,
                referenceTypePayments: state.referenceTypePayments,
                referenceTypePaymentsAll: state.referenceTypePaymentsAll,
                refererTypePaymentsNew: state.refererTypePaymentsNew,
                referenceSelfWriting: state.referenceSelfWriting,
                referenceSelfWritingAll: state.referenceSelfWritingAll,
                referenceSelfWritingNew: state.referenceSelfWritingNew,
                referenceWriting: state.referenceWriting,
                referenceWritingAll: state.referenceWritingAll,
                referenceWritingNew: state.referenceWritingNew,
                referenceMoving: state.referenceMoving,
                referenceMovingAll: state.referenceMovingAll,
                referenceMovingNew: state.referenceMovingNew,
                referenceConsignment: state.referenceConsignment,
                referenceConsignmentAll: state.referenceConsignmentAll,
                referenceConsignmentNew: state.referenceConsignmentNew,
                referenceStocktaking: state.referenceStocktaking,
                referenceStocktakingAll: state.referenceStocktakingAll,
                referenceStocktakingNew: state.referenceStocktakingNew,
                referenceOutput: state.referenceOutput,
                referenceOutputAll: state.referenceOutputAll,
                referenceOutputNew: state.referenceOutputNew,
                referenceChangeList: state.referenceChangeList,
                referenceChangeListAll: state.referenceChangeListAll,
                referenceChangeListNew: state.referenceChangeListNew,
                referenceMarks: state.referenceMarks,
                referenceMarksAll: state.referenceMarksAll,
                referenceMarksNew: state.referenceMarksNew,
                referenceSuppliers: state.referenceSuppliers,
                referenceSuppliersAll: state.referenceSuppliersAll,
                referenceSuppliersNew: state.referenceSuppliersNew,
                referenceUnits: state.referenceUnits,
                referenceUnitsAll: state.referenceUnitsAll,
                referenceUnitsNew: state.referenceUnitsNew,
                referenceStreet: state.referenceStreet,
                referenceStreetAll: state.referenceStreetAll,
                referenceStreetNew: state.referenceStreetNew,
                referenceMarkup: state.referenceMarkup,
                referenceMarkupAll: state.referenceMarkupAll,
                referenceMarkupNew: state.referenceMarkupNew,
                referencePositionWorker: state.referencePositionWorker,
                referencePositionWorkerAll: state.referencePositionWorkerAll,
                referencePositionWorkerNew: state.referencePositionWorkerNew,
                referenceDiscount: state.referenceDiscount,
                referenceDiscountAll: state.referenceDiscountAll,
                referenceDiscountNew: state.referenceDiscountNew,
                referenceOrganization: state.referenceOrganization,
                referenceOrganizationAll: state.referenceOrganizationAll,
                referenceOrganizationNew: state.referenceOrganizationNew,
                referenceEmployeesList: state.referenceEmployeesList,
                referenceEmployeesListAll: state.referenceEmployeesListAll,
                referenceEmployeesListNew: state.referenceEmployeesListNew,
                referenceUserList: state.referenceUserList,
                referenceUserListAll: state.referenceUserListAll,
                referenceUserListNew: state.referenceUserListNew,
                referencePromoCreate: state.referencePromoCreate,
                referencePromoCreateAll: state.referencePromoCreateAll,
                referencePromoCreateNew: state.referencePromoCreateNew,
                referenceCertificate: state.referenceCertificate,
                referenceCertificateAll: state.referenceCertificateAll,
                referenceCertificateNew: state.referenceCertificateNew,
                referencePromocode: state.referencePromocode,
                referencePromocodeAll: state.referencePromocodeAll,
                referencePromocodeNew: state.referencePromocodeNew,
                affiliate: state.affiliate,
                affiliateAll: state.affiliateAll,
                affiliateNew: state.affiliateNew,
                gifts: state.gifts,
                giftsAll: state.giftsAll,
                giftsNew: state.giftsNew,
                outlets: state.outlets,
                outletsAll: state.outletsAll,
                outletsNew: state.outletsNew,
                category: state.category,
                categoryAll: state.categoryAll,
                categoryNew: state.categoryNew,
                productTags: state.productTags,
                productTagsAll: state.productTagsAll,
                productTagsNew: state.productTagsNew,
                productList: state.productList,
                productListAll: state.productListAll,
                productListNew: state.productListNew,
                catalogLoadError: state.catalogLoadError,
                settings: state.systemColor,
                statusLoadServerInfo:state.statusLoadServerInfo,
                catalogReady:state.catalogReady,
                orderReferencesReady:state.orderReferencesReady,
                adminReferencesReady:state.adminReferencesReady,
                setUpdateSortable,
                getAllColorServer,
                getALlNotesServer,
                setActiveNotes,
                setUpdateNotes,
                setDeletedNotes,
                setSaveNewNotes,
                getALlOrderSourceServer,
                setActiveOrderSource,
                setUpdateOrderSource,
                setDeletedOrderSource,
                setSaveNewOrderSource,
                getALlStatusOrderServer,
                setActiveStatusOrder,
                setUpdateStatusOrder,
                setDeletedStatusOrder,
                setSaveNewStatusOrder,
                getALlWriteOffServer,
                setActiveWriteOff,
                setUpdateWriteOff,
                setDeletedWriteOff,
                setSaveNewWriteOff,
                getALlTypePaymentsServer,
                setActiveTypePayments,
                setUpdateTypePayments,
                setDeletedTypePayments,
                setSaveNewTypePayments,
                getALlSelfWritingServer,
                setActiveSelfWriting,
                setUpdateSelfWriting,
                setDeletedSelfWriting,
                setSaveNewSelfWriting,
                getALlWritingServer,
                setActiveWriting,
                setUpdateWriting,
                setDeletedWriting,
                setSaveNewWriting,
                getALlMovingServer,
                setActiveMoving,
                setUpdateMoving,
                setDeletedMoving,
                setSaveNewMoving,
                getALlConsignmentServer,
                setActiveConsignment,
                setUpdateConsignment,
                setDeletedConsignment,
                setSaveNewConsignment,
                getALlStocktakingServer,
                setActiveStocktaking,
                setUpdateStocktaking,
                setDeletedStocktaking,
                setSaveNewStocktaking,
                getALlOutputServer,
                setActiveOutput,
                setUpdateOutput,
                setDeletedOutput,
                setSaveNewOutput,
                getAllChangeListServer,
                setActiveChangeList,
                setUpdateChangeList,
                setDeletedChangeList,
                setSaveNewChangeList,
                getAllMarksServer,
                setActiveMarks,
                setUpdateMarks,
                setDeletedMarks,
                setSaveNewMarks,
                getAllSuppliersServer,
                setActiveSuppliers,
                setUpdateSuppliers,
                setDeletedSuppliers,
                setSaveNewSuppliers,
                getAllUnitsServer,
                setActiveUnits,
                setUpdateUnits,
                setDeletedUnits,
                setSaveNewUnits,
                getAllStreetServer,
                setActiveStreet,
                setUpdateStreet,
                setDeletedStreet,
                setSaveNewStreet,
                getAllMarkupServer,
                setActiveMarkup,
                setUpdateMarkup,
                setDeletedMarkup,
                setSaveNewMarkup,
                getAllPositionWorkerServer,
                setActivePositionWorker,
                setUpdatePositionWorker,
                setDeletedPositionWorker,
                setSaveNewPositionWorker,
                getAllDiscountServer,
                setActiveDiscount,
                setUpdateDiscount,
                setDeletedDiscount,
                setSaveNewDiscount,
                getAllOrganizationServer,
                setActiveOrganization,
                setUpdateOrganization,
                setDeletedOrganization,
                setSaveNewOrganization,
                getAllEmployeesListServer,
                setActiveEmployeesList,
                setUpdateEmployeesList,
                setDeletedEmployeesList,
                setSaveNewEmployeesList,
                getAllUserListServer,
                setActiveUserList,
                setUpdateUserList,
                setDeletedUserList,
                setSaveNewUserList,
                getAllPromoCreateListServer,
                setActivePromoCreate,
                setUpdatePromoCreate,
                setDeletedPromoCreate,
                setSaveNewPromoCreate,
                setUpdatePromoCreateCategory,
                setDeletedPromoCreateCategory,
                setSaveNewPromoCreateCategory,
                getAllCertificateServer,
                setActiveCertificate,
                setUpdateCertificate,
                setDeletedCertificate,
                setSaveNewCertificate,
                getAllPromocodeServer,
                setActivePromocode,
                setUpdatePromocode,
                setDeletedPromocode,
                setSaveNewPromocode,
                getAllAffiliateServer,
                setActiveAffiliate,
                setUpdateAffiliate,
                setDeletedAffiliate,
                setSaveNewAffiliate,
                getAllGiftsServer,
                setActiveGifts,
                setUpdateGifts,
                setDeletedGifts,
                setSaveNewGifts,
                getAllOutletsServer,
                setActiveOutlets,
                setUpdateOutlets,
                setDeletedOutlets,
                setSaveNewOutlets,
                getAllCategoryServer,
                setActiveCategory,
                setUpdateCategory,
                generateCategoryProductArticles,
                setUpdateCategorySortable,
                setDeletedCategory,
                setSaveNewCategory,
                getAllProductTagsServer,
                setActiveProductTag,
                setUpdateProductTag,
                setDeletedProductTag,
                setSaveNewProductTag,
                getAllProductListServer,
                setActiveProductList,
                setUpdateProductList,
                setUpdateProductListImg,
                setDeletedProductList,
                setSaveNewProductList,
                setNewOrder,
                setEditOrder,
                deletedOrderUser,
                setStatusOrderUser,
                setWorkerOrderUser,
                setTypePaymentOrder,
                setStatusLoadServerInfo
            }

    const storeRef = useRef(null)
    if (!storeRef.current) {
        const listeners = new Set()
        const actionWrappers = new Map()
        const store = {
            value: contextValue,
            subscribe: (listener) => {
                listeners.add(listener)
                return () => listeners.delete(listener)
            },
            notify: (changedKeys) => listeners.forEach((listener) => listener(changedKeys)),
            getValue: (key) => {
                const value = store.value[key]
                if (typeof value !== 'function') return value

                if (!actionWrappers.has(key)) {
                    actionWrappers.set(key, (...args) => store.value[key](...args))
                }
                return actionWrappers.get(key)
            },
        }
        storeRef.current = store
    }

    const store = storeRef.current
    const previousValueRef = useRef(contextValue)
    store.value = contextValue

    useEffect(() => {
        const previousValue = previousValueRef.current
        const changedKeys = new Set()

        Object.keys(contextValue).forEach((key) => {
            if (
                typeof contextValue[key] !== 'function' &&
                !Object.is(previousValue[key], contextValue[key])
            ) {
                changedKeys.add(key)
            }
        })

        previousValueRef.current = contextValue
        if (changedKeys.size) store.notify(changedKeys)
    })

    return (
        <SystemServerInfoContext.Provider value={store}>
            {children}
            <WarehouseDispositionDialog
                state={warehouseDispositionDialog}
                onCancel={() => closeWarehouseDisposition(false)}
                onConfirm={(value) => closeWarehouseDisposition({
                    ...value,
                    target_status_id: warehouseDispositionDialog?.idStatus || 0,
                    is_delete: Boolean(warehouseDispositionDialog?.isDelete),
                    idempotency_key: warehouseDispositionDialog?.idempotencyKey || '',
                })}
            />
        </SystemServerInfoContext.Provider>
    )

};

export default SystemServerInfoContext
